import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { getPowerListAPI } from '@/apis/power'
import { message } from 'antd'

const PermissionContext = createContext({ has: () => false, loading: true, list: [] })

export const PermissionProvider = ({ children }) => {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(()=>{
    let mounted = true
    getPowerListAPI().then(res=>{
      if(!mounted) return
      if(res.code===0 && Array.isArray(res.data)) setList(res.data)
      else message.error('权限获取失败')
    }).catch(()=>{ if(mounted) message.error('权限获取失败') }).finally(()=> mounted && setLoading(false))
    return ()=> { mounted=false }
  },[])

  useEffect(()=>{
    if(!loading) {
      console.debug('[PermissionProvider] list=', list)
    }
  },[loading, list])

  const has = useCallback((key)=> list.includes(key), [list])

  return <PermissionContext.Provider value={{ has, loading, list }}>{children}</PermissionContext.Provider>
}

export const usePermission = () => useContext(PermissionContext)
